import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";
import { normalizeUploadedImageUrl } from "./uploadImage";

// Cache dùng chung cho toàn bộ app, tránh fetch lại khi đã có data
const cache = {};
// Lưu promise đang chạy để tránh fetch song song cùng một ngôn ngữ
const pendingRequests = {};

/**
 * Lấy danh sách dự án tiêu biểu theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách dự án tiêu biểu
 */
export const getTypicalProjectsByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.TYPICAL_PROJECTS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;
        let result = [];

        if (data && data.success && Array.isArray(data.data)) {
            result = data.data;
        } else if (Array.isArray(data)) {
            result = data;
        } else if (data && Array.isArray(data.data)) {
            result = data.data;
        }

        return result.map(p => ({
            ...p,
            image: normalizeUploadedImageUrl(p.image || p.imageUrl || ''),
            overviewImage: normalizeUploadedImageUrl(p.overviewImage || ''),
            websiteUrl: p.websiteUrl || p.WebsiteUrl || null,
        }));
    } catch (error) {
        console.error("Lỗi khi lấy danh sách dự án tiêu biểu:", error);
        throw error;
    }
};
